// extracted by mini-css-extract-plugin
module.exports = {"tabHeader":"TabsContainer_tabHeader__3kloq"};